import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import useCourse from '@/composables/useCourse'
  import PackageCoursesSlider from '@/components/course/PackageCoursesSlider.vue'
  import { CourseModule } from '@/store/modules/course'
  import PackagePriceSection from '@/components/course/PackagePriceSection.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PackageInfo',
  setup(__props) {

  const { packageId, courseBundle, fetchAllCourseModules, productPrice } = useCourse()

  const loadingPackage = computed(() => courseBundle.value === null)

  CourseModule.getPackageBundle(packageId.value).finally(() => {
    fetchAllCourseModules(courseBundle.value!.courses.map((course) => course.id))
  })

  onMounted(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  })

return { __sfc: true,packageId, courseBundle, fetchAllCourseModules, productPrice, loadingPackage, computed, onMounted, LoadingSpinner, HTMLRenderer, useCourse, PackageCoursesSlider, CourseModule, PackagePriceSection }
}

})